var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isLocal(_vm.filename))?_c('b-img',{class:{ 'sharp-image': _vm.sharp },attrs:{"src":require(`~img/${_vm.filename}`),"srcset":`
    ${require(`~img/${_vm.filename}`)} 1x ${_setup.exists(_setup.filenameRetina(_vm.filename)) ? `,
    ${require(`~img/${_setup.filenameRetina(_vm.filename)}`)} 2x` : ''}`}}):_c('b-img',{attrs:{"src":_vm.filename}})
}
var staticRenderFns = []

export { render, staticRenderFns }